/**
 * Get session date from created_at_ts (Unix timestamp) or fallback to created_at (ISO string)
 * @param session - Session object with created_at_ts and/or created_at
 * @returns Date object
 */
export const getSessionDate = (session: {
  created_at_ts?: number | null;
  created_at?: string | null;
  createdAt?: string | null;
}): Date => {
  // Primary: use created_at_ts (Unix timestamp in seconds)
  if (session.created_at_ts && session.created_at_ts > 0) {
    return new Date(session.created_at_ts * 1000);
  }

  // Fallback: use created_at (Strapi auto-generated ISO string)
  if (session.created_at) {
    return new Date(session.created_at);
  }

  // Fallback: use createdAt (alternative naming convention)
  if (session.createdAt) {
    return new Date(session.createdAt);
  }

  // Last resort: return current date (should not happen)
  return new Date();
};

/**
 * Get session timestamp in milliseconds
 * @param session - Session object with created_at_ts and/or created_at
 * @returns Timestamp in milliseconds
 */
export const getSessionTimestamp = (session: {
  created_at_ts?: number | null;
  created_at?: string | null;
  createdAt?: string | null;
}): number => {
  return getSessionDate(session).getTime();
};
